import * as interventionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { SEND_SELF_SERVICE_SUCCESS } from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

export const REFRESH_INTERVENTION_CHAT_ACTIONS = [
  SEND_SELF_SERVICE_SUCCESS,
  interventionTypes.SEND_INTERVENTION_SUCCESS,
  interventionTypes.UPDATE_INTERVENTION_STATUS_SUCCESS,
];

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_MESSAGES]: isLoading,
  [actionTypes.FETCH_CONVERSATION]: isLoading,

  ...REFRESH_INTERVENTION_CHAT_ACTIONS.reduce((acc, action) => ({ ...acc, [action]: isLoading }), {}),

  [LOCATION_CHANGE]: isEnding,
  [actionTypes.FETCH_MESSAGES_SUCCESS]: isEnding,
  [actionTypes.FETCH_MESSAGES_FAILURE]: isEnding,
  [actionTypes.FETCH_CONVERSATION_SUCCESS]: isEnding,
  [actionTypes.FETCH_CONVERSATION_FAILURE]: isEnding,
});
